import * as React from 'react';
import { SocialBarThemesType } from './types';

export const SocialBarContext = React.createContext<SocialBarThemesType>(null);

export const SocialBarProvider = SocialBarContext.Provider;

export const useSocialBarContext = () => React.useContext(SocialBarContext);
